module.exports = __webpack_public_path__ + "img/pr-31.8564d330.png";